import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useStore } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import ApproveWfh from "./ApproveWfh";
import RequestCategoryToggle from "../../../../components/RequestCategoryToggle";

const ApproveLeave = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") === "wfh" ? "WFH/BT" : "Leave"
  );
  const navigate = useNavigate();
  const [approveLeave, setApproveLeave] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [selectedLeaveId, setSelectedLeaveId] = useState(null);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [loading, setLoading] = useState({
    approve: false,
    reject: false
  });
  
  const columns = {
    Name: { text: "Employee", visible: true },
    TXNDate: { text: "Applied Date", align: "center", visible: true },
    FromDate: { text: "From Date", align: "center", visible: true },
    ToDate: { text: "To Date", align: "center", visible: true },
    Purpose: { text: "Purpose", visible: true },
    ApplicationStatus: { text: "Status", visible: true },
  };
  const defaultColumns = {
    Name: true,
    TXNDate: true,
    Purpose: true,
    ToDate: true,
    FromDate: true,
    ApplicationStatus: true,
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Approve Leave"));
  }, []);
  useEffect(() => {
    fetchApproveLeave();
  }, []);

  const fetchApproveLeave = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}approve-leave`);
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const LeaveData = response?.data?.header;
        setApproveLeave(LeaveData);
      } else {
        console.error(
          "Failed to fetch Leave. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Leave:", error);
    }
  };

  const handleView = (id) => {
    navigate(`/approve-leave/leave-report/emp/${id.ID}`);
  };

  const [selectedApproveData, setSelectedApproveData] = useState();
  console.log("selectedApproveData", selectedApproveData);

  const handleApproveModel = (id) => {
    setSelectedApproveData(id);
    setSelectedLeaveId(id.ID);
    setShowModal(true);
  };

  const handleRejectModel = (id) => {
    setSelectedLeaveId(id.ID);
    setRejectModal(true);
  };

  const handleApprove = async (event) => {
    event.preventDefault();
    await leaveStatus(826);
  };

  const handleReject = async (event) => {
    event.preventDefault();
    await leaveStatus(827);
  };

  const leaveStatus = async (status) => {
    // Set loading state based on action
    if (status === 826) {
      setLoading(prev => ({ ...prev, approve: true }));
    } else {
      setLoading(prev => ({ ...prev, reject: true }));
    }

    try {
      const response = await PostServiceCaller(
        `${API_URL}manager-approve-leave/${selectedLeaveId}`,
        {
          FromDate: selectedApproveData?.FromDate,
          ToDate: selectedApproveData?.ToDate,
          EmployeeID: selectedApproveData?.EmployeeID,
          dates: selectedApproveData?.dates,
          leavepurpose: selectedApproveData?.Purpose,
          leaveID: selectedApproveData?.leaveID,
          rowstatus: 436,
          revisionNumber: selectedApproveData?.RevisionNumber,
          leavestatus: status,
        },
        "post"
      );

      if (status === 826) {
        toast.success("Leave Application Approved Successfully!");
      } else if (status === 827) {
        toast.success("Leave Application Rejected Successfully!");
      }
      fetchApproveLeave();
      setShowModal(false);
      setRejectModal(false);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to process request. Please try again.");
    } finally {
      // Reset loading states
      setLoading({ approve: false, reject: false });
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        {activeTab === "Leave" && (
          <div className="container-fluid" id="skill-table-area">
            <RequestCategoryToggle activeTab={activeTab} setActiveTab={setActiveTab} />
            <div className="row">
            <Dynamic_PR_table
              data={approveLeave}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={true}
              showIcon3={true}
              isSorting={true}
              isActionRequired={true}
              handleIcon1={handleView}
              handleIcon2={handleApproveModel}
              handleIcon3={handleRejectModel}
              add
              more
              function
              icons={{
                Icon1: <i className="bi bi-eye-fill"></i>,
                Icon1Text: "View Leave Details",

                Icon2: <i className="fa fa-check"></i>,
                Icon2Text: "Approved Leave",
                Icon2Flag: "canApprove",
                Icon3: <i className="fa fa-close"></i>,
                Icon3Text: "Reject Leave",
                Icon3Flag: "canReject",
              }}
            />
          </div>
          {/* Approve Form */}
          {showModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px",
                margin: 0
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Approve Leave</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setShowModal(false)}
                      disabled={loading.approve}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleApprove}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            placeholder="Remark"
                            disabled={loading.approve}
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setShowModal(false)}
                          disabled={loading.approve}
                        >
                          Cancel
                        </button>
                        <button 
                          type="submit" 
                          className="custom-btn-sm"
                          disabled={loading.approve}
                          style={{
                            position: 'relative',
                            minWidth: '80px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {loading.approve ? (
                            <>
                              <span 
                                className="spinner-border spinner-border-sm" 
                                role="status" 
                                aria-hidden="true"
                                style={{
                                  width: '1rem',
                                  height: '1rem',
                                  borderWidth: '0.15em'
                                }}
                              ></span>
                              <span>Approving...</span>
                            </>
                          ) : (
                            "Approve"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Reject Form */}
          {rejectModal && (
            <div
              className="modal"
              tabIndex="-1"
              role="dialog"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050
              }}
            >
              <div className="modal-dialog modal-sm" role="document" style={{
                width: "300px",
                margin: 0
              }}>
                <div className="modal-content">
                  <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px 8px 0 0'
                  }}>
                    <p style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#27568B',
                      margin: '0'
                    }}>Reject Leave</p>
                    <button
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                        color: '#000',
                        padding: '4px',
                        borderRadius: '4px',
                        transition: 'all 0.2s',
                        lineHeight: '1'
                      }}
                      onClick={() => setRejectModal(false)}
                      disabled={loading.reject}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <div className="modal-body p-2">
                    <form onSubmit={handleReject}>
                      <div className="row">
                        <div className="col-md-12">
                          <textarea
                            type="text"
                            className="form-control"
                            id="Remark"
                            aria-describedby="Remark"
                            name="Remark"
                            placeholder="Remark"
                            disabled={loading.reject}
                          />
                        </div>
                      </div>
                      <div className="text-end mt-3">
                        <button
                          type="button"
                          className="cancel-btn-sm me-2"
                          onClick={() => setRejectModal(false)}
                          disabled={loading.reject}
                        >
                          Cancel
                        </button>
                        <button 
                          type="submit" 
                          className="custom-btn-sm"
                          disabled={loading.reject}
                          style={{
                            position: 'relative',
                            minWidth: '80px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          {loading.reject ? (
                            <>
                              <span 
                                className="spinner-border spinner-border-sm" 
                                role="status" 
                                aria-hidden="true"
                                style={{
                                  width: '1rem',
                                  height: '1rem',
                                  borderWidth: '0.15em'
                                }}
                              ></span>
                              <span>Rejecting...</span>
                            </>
                          ) : (
                            "Reject"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        )}
        
        <div style={{ display: activeTab === "WFH/BT" ? "block" : "none" }}>
          <ApproveWfh activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>
    </>
  );
};

export default ApproveLeave;